/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { map, memoize } from 'lodash';

import messages from './OfferCollectionOperator.messages';

const isEmptyOperators = [
  {
    label: <FormattedMessage {...messages.offerCollection.isEmpty} />,
    value: 'isEmpty',
    valueTypes: []
  },
  {
    label: <FormattedMessage {...messages.offerCollection.isNotEmpty} />,
    value: 'isNotEmpty',
    valueTypes: []
  }
];

export const multiOperators = [
  {
    label: <FormattedMessage {...messages.offerCollection.isIn} />,
    value: 'contains',
    valueTypes: ['LOOKUP']
  },
  {
    label: <FormattedMessage {...messages.offerCollection.isNotIn} />,
    value: 'notContains',
    valueTypes: ['LOOKUP']
  },
  ...isEmptyOperators
];

export const operators = [
  {
    label: <FormattedMessage {...messages.offerCollection.is} />,
    value: 'contains',
    valueTypes: ['LOOKUP']
  },
  {
    label: <FormattedMessage {...messages.offerCollection.isNot} />,
    value: 'notContains',
    valueTypes: ['LOOKUP']
  },
  ...isEmptyOperators
];

const getOperators = memoize(field => {
  let fieldOperators;
  if (
    (field.type === 'LOOKUP' && field.attributes.isMulti) ||
    field.type === 'STRING_ARRAY'
  ) {
    fieldOperators = multiOperators;
  } else {
    fieldOperators = operators;
  }

  return fieldOperators.map(operator => ({
    ...operator,
    valueTypes: map(operator.valueTypes, () => field.type) || []
  }));
});

export default {
  name: 'offerCollectionProvider',
  order: 0,
  getOperators: field => {
    const { type } = field;
    const orderCollection = field.attributes?.offerCollection;
    if (orderCollection && (type === 'LOOKUP' || type === 'STRING_ARRAY')) {
      return getOperators(field);
    }
  }
};
